import React, { Component } from 'react';

class Program extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        return (
            <section className="program-inner">
                <h3>Program</h3>
                <div className="program-into">
                    <p>
                        Processing Community Day @ Coimbra will take place on the 9th of December 2020, fully online.
                    </p>
                    <p>
                        This is a preliminary program. Please keep an eye on our website or subscribe our <a href="https://mailchi.mp/c04373c6b862/pcdcoimbra" target="_blank" rel="noopener noreferrer" >mailing list</a> to
                        get updates!
                    </p>
                </div>
                <div className="program-keynote s-t">
                    <h4 className="upper">14h00 (UTC) – Keynote Session</h4>
                    {/*<p>(more information soon)</p>*/}
                    <p><b>Vera van de Seyp</b><br/>
                        <span className="p light"><a href='https://veravandeseyp.com/' target="_blank" rel="noopener noreferrer">Vera van de Seyp</a> is a graphic designer, creative coder and media artist. She has great interest in artificial intelligence, languages and finding systems in chaos. She works in Amsterdam as designer and artist, teaches at ArtEZ, and gives workshops and lectures across Europe.<br/>
                    </span>
                    </p>
                </div>
                <div className="program-talks s-t">
                    <h4 className="upper">15h00 (UTC) – Presentation Session</h4>
                    <p className="p light">This session will consist of short presentations by five invited speakers, followed by an open discussion panel.</p>
                    <p>
                        <span className="p light"><b><a href='http://www.thedotisblack.com' target="_blank" rel="noopener noreferrer">David Mrugala</a></b><br/>
                            <b><a href='http://www.angharadhengyu.xyz' target="_blank" rel="noopener noreferrer">Angharad Hengyu Owen</a></b><br/>
                            <b><a href='https://cdv.dei.uc.pt/authors/bruna-sousa/' target="_blank" rel="noopener noreferrer">Bruna de Sousa</a> and <a href='http://www.josemariacunha.com/' target="_blank" rel="noopener noreferrer">José Maria Cunha</a></b><br/>
                            <b><a href='https://www.pizza-punk.com' target="_blank" rel="noopener noreferrer">Jérôme Mercier</a></b><br/>
                            <b><a href='https://www.behance.net/vaniaoliveiradesign' target="_blank" rel="noopener noreferrer">Vânia Oliveira</a> and <a href='https://irenepeixoto.com/' target="_blank" rel="noopener noreferrer">Irene Peixoto</a></b>
                        </span>
                    </p>
                </div>
                <div className="program-workshops s-t">
                    <h4 className="upper">16h30 (UTC) – Workshop</h4>
                    <div>
                        <p><b>P5.js makes interactive webpages</b><br/>
                            <a href="https://www.behance.net/danifslopes" target="_blank" rel="noopener noreferrer" >Daniel Lopes</a> and <a href="https://cdv.dei.uc.pt/authors/pedro-silva/" target="_blank" rel="noopener noreferrer" >Pedro Silva</a><br/>
                            <span className="p light">
                            Processing has been fostering interactive design by offering designers a simple high-level syntax for developing graphics in multiple programming languages such as Java or Python. P5 is a JavaScript library for taking the highest advantage of Processing capabilities on the web. This workshop focus on introducing P5 and featuring its potential for developing interactive web pages.
                            </span>
                        </p>
                    </div>
                </div>

            </section>
        );
    }
}

export default Program;